/** Agent role landing pages (Agent Roles footer) — public marketing routes at site root. */
export const MARKETING_SOLUTION_SLUGS = [
  "online-patient-coordinator",
  "scheduling-specialist",
  "online-support-agent",
  "front-desk-receptionist",
  "new-student-advisor",
  "online-sales-rep",
] as const;

export type MarketingSolutionSlug = (typeof MARKETING_SOLUTION_SLUGS)[number];

export function isMarketingSolutionSlug(slug: string): slug is MarketingSolutionSlug {
  return (MARKETING_SOLUTION_SLUGS as readonly string[]).includes(slug);
}

/** Legacy Solutions URLs → new Agent Roles pages. */
export const LEGACY_SOLUTION_REDIRECTS: Record<string, MarketingSolutionSlug> = {
  "ai-receptionist-healthcare": "front-desk-receptionist",
  "ai-patient-coordinator": "online-patient-coordinator",
  "healthcare-ai-phone-agent": "front-desk-receptionist",
  "healthcare-ai-chat-agent": "online-support-agent",
  "dental-ai-receptionist": "front-desk-receptionist",
  "physical-therapy-ai-receptionist": "scheduling-specialist",
};
